import { createAsyncThunk } from "@reduxjs/toolkit";
import { i18nSliceName } from ".";

export const i18nSelectAction = createAsyncThunk(`${i18nSliceName}/i18nSelect`, async (language) => {
  const response = await require("../../../../config/langs/" + language.key + ".json");
  return {
    language,
    phrases: response,
  };
});
